const prod = {
    url : process.env.REACT_APP_PROD_URL
}
const dev = {
    url : process.env.REACT_APP_DEV_URL 
}

export const config = (process.env.REACT_APP_STAGE === 'dev') ? dev : prod;
export const MAX_AMOUNT = 10000;
export const CARD_CATEGORY_ID = 4;
// Product IDs
export const PRODUCT_IDS = {
    CARD_LOISIR: 9,
    CARD_CADEAU: 8,
    CARD_HABILLEMENT: 7,
    CARD_PLASTIC: 6,
    CARD_REPAS: 5,
    CHEQUE_REPAS: 1,
    CHEQUE_HABILLEMENT: 2,
    CHEQUE_CADEAU: 3
};

// Default values for cards
export const DEFAULT_CARD_VALUES = {
    [PRODUCT_IDS.CARD_LOISIR]: 300,
    [PRODUCT_IDS.CARD_CADEAU]: 200,
    [PRODUCT_IDS.CARD_HABILLEMENT]: 500,
    [PRODUCT_IDS.CARD_PLASTIC]: 17.5,
    [PRODUCT_IDS.CARD_REPAS]: 165
};

// Default values for cheques
export const DEFAULT_CHEQUE_VALUES = {
    [PRODUCT_IDS.CHEQUE_REPAS]: {
        value: 7,
        number: 22,
        quantity: 1
    },
    [PRODUCT_IDS.CHEQUE_HABILLEMENT]: {
        value: 10,
        number: 50,
        quantity: 1
    },
    [PRODUCT_IDS.CHEQUE_CADEAU]: {
        value: 5,
        number: 20,
        quantity: 1
    }
};

// Min and Max values for cheques
export const CHEQUE_VALIDATION_RULES = {
    [PRODUCT_IDS.CHEQUE_REPAS]: {
        minValue: 2,
        maxValue: 200
    },
    [PRODUCT_IDS.CHEQUE_HABILLEMENT]: {
        minValue: 10,
        maxValue: 9999
    },
    [PRODUCT_IDS.CHEQUE_CADEAU]: {
        minValue: 5,
        maxValue: 9999
    }
};